export default {
  data() {
    return {}
  },
  computed: {
    userEmail() {
      return this.$store.state.common.email
    },
  },
  watch: {
    userEmail(userEmail) {
      if (userEmail) {
        this.userEmailSnippet(userEmail)
        this.createAdRoll(userEmail)
      }
    },
  },
  mounted() {
    if (this.userEmail) {
      this.userEmailSnippet(this.userEmail)
      this.createAdRoll(this.userEmail)
    }
  },
  methods: {
    userEmailSnippet(userEmail) {
      const emailSnippet = `
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'email_address': '${userEmail}' });`

      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.innerHTML = emailSnippet
      document.body.appendChild(script)
    },
    createAdRoll(userEmail) {
      const adrollScript = `
      try {
        __adroll.record_user({"adroll_segments": "Enter the correct SegmentID", "email_address": '${userEmail}' });
    } catch(err) {}`

      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.innerHTML = adrollScript
      document.body.appendChild(script)
    },
  },
}
